import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import inquiryService from '../services/inquiry.service';


export const fetchInquiryList = createAsyncThunk(
  'inquiry/fetchInquiryList',
  async ({ page, pagesize, search, groupId, ordering }, thunkAPI) => {
    try {
      const response = await inquiryService.getInquiryList(page, pagesize, search, groupId, ordering);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const fetchArchivedInquiryList = createAsyncThunk(
  'inquiry/fetchArchivedInquiryList',
  async ({ page, pagesize, search, ordering }, thunkAPI) => {
    try {
      const response = await inquiryService.getInquiryArchiveList(page, pagesize, search, ordering);
      return response.data;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  },
);
export const fetchInquiryById = createAsyncThunk(
  'inquiry/fetchInquiryById',
  async (inquiryId, { rejectWithValue }) => {
    try {
      const response = await inquiryService.getInquiryById(inquiryId);
      return response.data; // Return the profile data
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createInquiry = createAsyncThunk(
  'inquiry/createInquiry',
  async ({ payload }, thunkAPI) => {
    try {
      const formData = new FormData();
      
      const cleanData = {
        ...payload,
        inquiry_details: payload?.inquiry_details?.map((item) => {
          const { drawing_file, ...rest } = item;
          return rest;
        }),
        source_of_inquiry_detail: [], // assuming handled separately
      };

      formData.append("data", JSON.stringify(cleanData));

      // 2️⃣ Append source attachment (if available)
      if (payload?.source_of_inquiry_detail?.length > 0) {
        const fileObj = payload?.source_of_inquiry_detail[0]?.originFileObj;
        if (fileObj) {
          formData.append("source_attachment", fileObj);
        }
      }

      // 3️⃣ Append multiple drawing attachments
      payload?.inquiry_details?.forEach((item, index) => {
        if (item.drawing_file?.length > 0) {
          const fileObj = item.drawing_file[0]?.originFileObj;
          if (fileObj) {
            formData.append(`drawing_attachment_${index}`, fileObj);
          }
        }
      });

      

      const response = await inquiryService.addInquiry(formData);
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createOpenInquiry = createAsyncThunk(
  'inquiry/createOpenInquiry',
  async ({ payload }, thunkAPI) => {
    try {
      const formData = new FormData();
      
      const cleanData = {
        ...payload,
        inquiry_details: payload?.inquiry_details?.map((item) => {
          const { drawing_file, ...rest } = item;
          return rest;
        }),
        source_of_inquiry_detail: [], // assuming handled separately
      };

      formData.append("data", JSON.stringify(cleanData));

      // 2️⃣ Append source attachment (if available)
      if (payload?.source_of_inquiry_detail?.length > 0) {
        const fileObj = payload?.source_of_inquiry_detail[0]?.originFileObj;
        if (fileObj) {
          formData.append("source_attachment", fileObj);
        }
      }

      // 3️⃣ Append multiple drawing attachments
      payload?.inquiry_details?.forEach((item, index) => {
        if (item.drawing_file?.length > 0) {
          const fileObj = item.drawing_file[0]?.originFileObj;
          if (fileObj) {
            formData.append(`drawing_attachment_${index}`, fileObj);
          }
        }
      });

      

      const response = await inquiryService.addOpenInquiry(formData);
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateInquiry = createAsyncThunk(
  'inquiry/updateInquiry',
  async ({ id, values, inquirySouceAttachmentList }, thunkAPI) => {
    try {
      const formData = new FormData();

      // 🧹 Prepare JSON data (without files)
      const cleanedData = {
        ...values,
        inquiry_details: values?.inquiry_details?.map((item) => {
          const { drawing_file, ...rest } = item;
          return rest;
        }),
        source_of_inquiry_detail: [], // assuming handled separately
      };

      formData.append("data", JSON.stringify(cleanedData));

      // 🧩 Source attachment (only new file)
      if (inquirySouceAttachmentList && inquirySouceAttachmentList.length > 0 && inquirySouceAttachmentList[0].originFileObj) {
        formData.append('source_attachment', inquirySouceAttachmentList[0].originFileObj);
      } else if (values.source_of_inquiry_detail === null) {

        formData.append('source_attachment', null);
      } else {

      }
      // if (values.source_of_inquiry_detail?.length > 0) {
      //   const fileObj = values.source_of_inquiry_detail[0];
      //   if (fileObj.originFileObj) {
      //     formData.append("source_attachment", fileObj.originFileObj);
      //   }
      // }

      // 🧩 Drawing attachments — append only new files
      values.inquiry_details.forEach((detail, index) => {
        const fileObj = detail.drawing_file?.[0];
        if (fileObj?.originFileObj) {
          // 🔸 This is a newly uploaded file
          formData.append(`drawing_attachment_${index}`, fileObj.originFileObj);
        }
      });
      const response = await inquiryService.editInquiry(id, formData);

      return response.data; // Return the updated customer data
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteInquiry = createAsyncThunk(
  'inquiry/deleteInquiry',
  async (id, thunkAPI) => {
    try {
      await inquiryService.deleteInquiry(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const unArchiveInquiry = createAsyncThunk(
  'inquiry/unArchiveInquiry',
  async (id, thunkAPI) => {
    try {
      await inquiryService.unArchiveInquiryRecord(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteInquiryDetailById = createAsyncThunk(
  'inquiry/deleteInquiryDetails',
  async (id, thunkAPI) => {
    try {
      await inquiryService.deleteInquiryDetails(id); // Ensure `id` is used here
      return id; // Return the ID of the deleted group
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const assignInquiry = createAsyncThunk(
  'inquiry/assignInquiry',
  async ({ id, payload }, thunkAPI) => {
    try {
      const response = await inquiryService.assignedInquiry(id, payload);
      const data = response.data; 
      
      if (!data?.success) {
        // 200 but business failure → reject so UI .catch runs
        return thunkAPI.rejectWithValue(data?.message || 'Assignment failed');
      }

      // return a clean shape for the reducer/UI
      return {
        success: data.success,
        message: data.message,
        inquiry: data?.data?.inquiry ?? data?.inquiry ?? null,
      };
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const assignFeasible = createAsyncThunk(
  'inquiry/assignFeasible',
  async ({ id, payload }, thunkAPI) => {
    try {
      const response = await inquiryService.setFeasibleStatusData(id, payload);
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const assignInquiryRegrettedReason = createAsyncThunk(
  'inquiry/assignInquiryRegrettedReason',
  async ({ id, payload }, thunkAPI) => {
    try {
      const response = await inquiryService.assignInquiryRegrettedReason(id, payload);
      return response.data;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  data: [],
  archiveData: [],
  totalPages: 0,
  currentPage: 1,
  totalRecord: 0,
  error: null,
  loading: false,
  hasMore: true,
};

const inquirySlice = createSlice({
  name: 'inquiry',
  initialState,
  reducers: {
    resetInquiryData: (state) => {
      state.data = []; // This will clear the list
    },
    resetArchiveData: (state) => {
      state.archiveData = []; // This will clear the list
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchInquiryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInquiryList.fulfilled, (state, action) => {
        const fetchedPage = action.payload.page || state.currentPage;
        state.data = action.payload.results.data || [];  // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.totalPages = action.payload.totalPages || 0; // Handle totalPages
        state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
        state.hasMore = !!action.payload.next;
        state.loading = false;
      })
      .addCase(fetchInquiryList.rejected, (state, action) => {
        state.loading = false;
      });
    builder
      .addCase(fetchArchivedInquiryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchArchivedInquiryList.fulfilled, (state, action) => {
        state.status = 'succeeded';

        state.archiveData = action.payload.results.data || [];  // Update to match your API response
        state.totalRecord = action.payload.count || 0; // Handle count (total records)
        state.hasMore = !!action.payload.next;
        state.loading = false;
      })
      .addCase(fetchArchivedInquiryList.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
      });
    builder
      .addCase(fetchInquiryById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInquiryById.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchInquiryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(createInquiry.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createInquiry.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createInquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });

       builder
      .addCase(createOpenInquiry.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createOpenInquiry.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createOpenInquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
    builder
      .addCase(updateInquiry.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateInquiry.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(updateInquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
    builder
      .addCase(deleteInquiry.pending, state => {
        state.loading = true;
      })
      .addCase(deleteInquiry.fulfilled, (state, action) => {
        state.data = state.data.filter(group => group.id !== action?.meta?.arg); // Remove the deleted group from state
        state.totalRecord = state.totalRecord - 1;
        state.loading = false;
      })
      .addCase(deleteInquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(unArchiveInquiry.pending, state => {
        state.loading = true;
      })
      .addCase(unArchiveInquiry.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.archiveData = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
        state.loading = false;
      })
      .addCase(unArchiveInquiry.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(assignInquiry.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(assignInquiry.fulfilled, (state, action) => {
        state.loading = false;
        
       
          const updatedInquiry = action?.payload?.inquiry;
         if (updatedInquiry) {
          state.data = state.data.map(inquiry =>
            inquiry.id === updatedInquiry.id
              ? {
                ...inquiry,
                status: updatedInquiry.status,
                assigned_user_details: updatedInquiry.assigned_user_detail,
              }
              : inquiry
          );
        }
      })
      .addCase(assignInquiry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
    builder
      .addCase(assignFeasible.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(assignFeasible.fulfilled, (state, action) => {
        state.loading = false;

        const updatedInquiry = action?.payload?.data;

        state.data = state.data.map(inquiry =>
          inquiry.id === updatedInquiry.id
            ? {
              ...inquiry,
              status: updatedInquiry.status,
            }
            : inquiry
        );
      })
      .addCase(assignFeasible.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
    builder
      .addCase(assignInquiryRegrettedReason.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(assignInquiryRegrettedReason.fulfilled, (state, action) => {
        state.loading = false;
        const updatedInquiry = action?.payload?.data;
        state.data = state.data.map(inquiry =>
          inquiry.id === updatedInquiry.id
            ? {
              ...inquiry,
              status: updatedInquiry.status,
              regret_reason: updatedInquiry.regret_reason,
            }
            : inquiry
        );
      })
      .addCase(assignInquiryRegrettedReason.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});


export const { resetInquiryData, resetArchiveData } = inquirySlice.actions;
export default inquirySlice.reducer;


